export enum WorkflowType {
  QuestionAnswerText = 1,
  QuestionAnswerEmoji = 2,
  QuestionAnswer10Score = 3,
  QuestionAnswerYesNo = 4,
  QuestionAnswerMultilineText = 10,
  QuestionAnswerMultipleChoice = 11, // ラジオボタン
  QuestionAnswerCheckboxes = 12, // チェックボックス
  QuestionAnswerDropDown = 13, // セレクトボックス
  QuestionAnswerEmail = 14,
  QuestionAnswerName = 15,
  QuestionAnswerPhoneNumber = 16,
  QuestionAnswerHostInsertText = 17,
  Task = 100,
  Kudos = 200,
  Suggestion = 300,
}

export enum WorkflowTypeText {
  Text = 'text',
  SingleSelect = 'singleSelect',
  MultiSelect = 'multiSelect',
}
